export default __webpack_public_path__ + "static/media/4368.ae12496a.png";